// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { injectTMMIntoBasket } from '../../actions/mymatch';
import useMatchViewContext from '../../hooks/useMatchViewContext';
import useMergeProps from '../../hooks/useMergeProps';

import MatchTopMyMatchCard from './MatchTopMyMatchCard';
import makeMatchTopMyMatchCardPropsSelector from './MatchTopMyMatchCard.selector';

type MatchTopMyMatchCardContainerProps = {
  index: number;
  matchId: number;
};

const MatchTopMyMatchCardContainer = (props: MatchTopMyMatchCardContainerProps) => {
  const { index, matchId: matchIdFromProps, ...ownProps } = props;
  const dispatch = useDispatch();
  const { matchId: matchIdFromMatchView } = useMatchViewContext();

  const matchId = useMemo(() => matchIdFromProps ?? matchIdFromMatchView, [matchIdFromProps, matchIdFromMatchView]);

  const selectorProps = useMemo(() => ({ index, matchId }), [index, matchId]);
  const selector = useMemo(() => makeMatchTopMyMatchCardPropsSelector(), []);
  const { processedOutcomes, ...selectedProps } = useSelector((state) => selector(state, selectorProps));
  const { odds } = selectedProps;

  const onClick = useCallback(() => {
    dispatch(injectTMMIntoBasket({ matchId, outcomes: processedOutcomes, value: odds }));
  }, [matchId, processedOutcomes, odds, dispatch]);

  const otherProps = useMemo(() => ({ onClick }), [onClick]);

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <MatchTopMyMatchCard {...enhancedProps} />;
};

export default MatchTopMyMatchCardContainer;
